import React, { ReactNode } from 'react'
import * as Accordion from '@radix-ui/react-accordion'
type PropsWithChildren<P = unknown> = P & { children: ReactNode }
import * as styles from './Accordions.css'
import classNames from 'classnames'
import ArrowDown from '@/icons/navigation/iconArrowDown'

export const AccordionTrigger = ({
  children,
  variant = 'default',
}: PropsWithChildren<{
  children: React.ReactNode
  variant: 'default' | 'gray'
}>) => {
  return (
    <Accordion.Header
      className={classNames(styles.AccordionShowButton, {
        [styles.GrayFooter]: variant === 'gray',
      })}
    >
      <Accordion.Trigger className={styles.AccordionTrigger}>
        <div
          className={classNames('AccordionChevron', styles.Chevron)}
          aria-hidden
        >
          <ArrowDown aria-hidden />
        </div>
        {children}
      </Accordion.Trigger>
    </Accordion.Header>
  )
}

export const AccordionContent = (
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  { children, className, ...props }: React.PropsWithChildren<any>
) => {
  return (
    <Accordion.Content
      className={classNames('AccordionContentWrapper', className)}
      {...props}
      forceMount
    >
      <div className={classNames('AccordionContent', styles.AccordionContent)}>
        {children}
      </div>
    </Accordion.Content>
  )
}

export const AccordionTriggerGuidelines = ({
  children,
}: PropsWithChildren<{ children: React.ReactNode }>) => {
  return (
    <Accordion.Header className={styles.AccordionHeaderGuidelines}>
      <Accordion.Trigger className={styles.AccordionTriggerGuidelines}>
        {children}
        <div
          className={classNames('AccordionChevron', styles.Chevron)}
          aria-hidden
        >
          <ArrowDown aria-hidden />
        </div>
      </Accordion.Trigger>
    </Accordion.Header>
  )
}

export const MobileAccordionTrigger = ({
  children,
  variant = 'default',
}: PropsWithChildren<{
  children: React.ReactNode
  variant: 'default' | 'gray'
}>) => {
  return (
    <Accordion.Header>
      <Accordion.Trigger
        className={classNames(styles.MobileAccordionTrigger, {
          [styles.GrayFooter]: variant === 'gray',
        })}
      >
        {children}
        <div
          className={classNames('AccordionChevron', styles.Chevron)}
          aria-hidden
        >
          <ArrowDown aria-hidden />
        </div>
      </Accordion.Trigger>
    </Accordion.Header>
  )
}
